<template>
    <div class="Product">
        <menuBox :step="3"></menuBox>
        <div class="title-box">
            <div>Thỏa thuận dịch vụ và bảo vệ quyền riêng tư</div>
            <p>Thỏa thuận dịch vụ hợp tác cho vay và tiết kiệm VayNow và bảo vệ quyền riêng tư</p>
        </div>
        <div class="product-text">
            <h3>1. Giới thiệu</h3>
            <br> Chào mừng bạn đến với dịch vụ vay VayNow. Chúng tôi có trách nhiệm tôn trọng quyền riêng tư của bạn và Thỏa thuận này giải thích những dữ liệu cá nhân nào chúng tôi thu thập, lý do chúng tôi sử dụng dữ liệu đó và cách chúng tôi lưu trữ cũng như cách chúng tôi bảo vệ dữ liệu đó.
            <h3>2. Thu thập dữ liệu</h3>
            <br> Khi bạn sử dụng dịch vụ của chúng tôi, chúng tôi có thể thu thập thông tin nhận dạng của bạn, bao gồm tên, ngày sinh, giới tính và các thông tin nhận dạng cơ bản khác để nhận dạng bạn và cung cấp các dịch vụ được cá nhân hóa.
            <h3> 3. Sử dụng dữ liệu</h3>
            <br> Chúng tôi sử dụng thông tin phi cá nhân để phân tích hành vi và sở thích của người dùng nhằm cải thiện hiệu suất ứng dụng và trải nghiệm người dùng. Dữ liệu này giúp chúng tôi hiểu những tính năng nào phổ biến và những tính năng nào cần cải thiện.
            <h3>4. Chia sẻ dữ liệu</h3>
            <br> Với sự đồng ý của bạn, các ứng dụng của chúng tôi có thể cần chia sẻ dữ liệu với bên thứ ba để cung cấp dịch vụ hoặc tuân thủ các nghĩa vụ pháp lý. Các bên thứ ba này có thể bao gồm ngân hàng, tổ chức tài chính, đối tác và cơ quan quản lý. Trong trường hợp này, chúng tôi sẽ thực hiện các biện pháp thích hợp để bảo vệ thông tin cá nhân của bạn và tuân thủ nghiêm ngặt luật pháp và quy định hiện hành.
            <h3> 5. Bảo mật dữ liệu</h3>
            <br> Chúng tôi thực hiện các biện pháp kỹ thuật và tổ chức phù hợp để bảo vệ thông tin cá nhân của bạn khỏi bị truy cập, sử dụng hoặc tiết lộ trái phép. Chúng tôi lưu trữ thông tin cá nhân của bạn trên các máy chủ an toàn và thực hiện các bước để ngăn chặn rò rỉ và lạm dụng dữ liệu.
            <h3>6. Quyền của người dùng</h3>
            <br> Bạn có thể rút lại sự đồng ý của mình đối với việc chúng tôi thu thập và xử lý thông tin cá nhân của bạn bất cứ lúc nào. Xin lưu ý rằng sau khi bạn rút lại sự đồng ý, chúng tôi có thể không còn có thể cung cấp cho bạn một số dịch vụ nhất định, chẳng hạn như đơn xin vay tiền hoặc dịch vụ tài chính. Nếu bạn muốn rút lại sự đồng ý của mình, vui lòng liên hệ với chúng tôi và chúng tôi sẽ cung cấp hướng dẫn và hỗ trợ.
            <h3>7. Thay đổi chính sách quyền riêng tư</h3>
            <br> Chúng tôi có quyền sửa đổi hoặc cập nhật Chính sách quyền riêng tư này bất cứ lúc nào. Nếu chúng tôi thực hiện những thay đổi quan trọng đối với chính sách của mình, chúng tôi sẽ thông báo cho bạn qua trang web.
            <h3> 8. Điều khoản dịch vụ</h3>
            <br> Khi bạn sử dụng dịch vụ của chúng tôi, chúng tôi cho rằng bạn đã đồng ý với Thỏa thuận này. Nếu bạn không đồng ý với bất kỳ nội dung nào của Thỏa thuận này, vui lòng không sử dụng dịch vụ của chúng tôi.
            <h3>9. Tuyên bố từ chối trách nhiệm</h3>
            <br> Chúng tôi không chịu trách nhiệm về bất kỳ sự mất mát hoặc rò rỉ dữ liệu nào do trường hợp bất khả kháng hoặc các sự kiện nằm ngoài tầm kiểm soát của chúng tôi.
            <h3>10. Luật áp dụng</h3>
            <br> Việc giải thích và thực hiện Thỏa thuận này sẽ tuân theo pháp luật Việt Nam và chịu sự phán quyết của tòa án Việt Nam.
        </div>
        <div class="pattom"></div>
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.title-box {
    width: 100%;
    height: 380px;
    background: #1F65FF;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;

    div {
        font-size: 40px;
        font-weight: bold;
    }

    p {
        margin-top: 43px;
        font-size: 16px;
    }
}

.product-text {
    padding: 80px 360px;
    font-size: 18px;
    line-height: 2em;
}
</style>
